import { css } from '@emotion/react'

export const link = css`
  cursor: pointer;
`
